export default __webpack_public_path__ + "524ff6b65345a99e53aa14777da1cd17.png";